import {
  AssignContainerToNumericReleaseCommand,
  CreateNumericReleaseCommand,
  NumericReleasesApi,
  UnassignContainerFromNumericReleaseCommand,
  UpdateNumericReleaseCommand,
} from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class NumericReleaseService {
  httpClient = createApiClient(NumericReleasesApi)

  async getById(id: number) {
    const { data } = await this.httpClient.getById(id)
    return data
  }

  async post(cmd: CreateNumericReleaseCommand) {
    await this.httpClient.create(cmd)
  }

  async put(cmd: UpdateNumericReleaseCommand) {
    await this.httpClient.update(cmd)
  }

  async assignContainer(cmd: AssignContainerToNumericReleaseCommand) {
    await this.httpClient.assignContainer(cmd)
  }

  async unassignContainer(cmd: UnassignContainerFromNumericReleaseCommand) {
    await this.httpClient.unassignContainer(cmd)
  }

  async delete(id: number) {
    await this.httpClient._delete(id)
  }
}

const numericReleaseService = new NumericReleaseService()

export default numericReleaseService
